<div class="hol-box decision-box">
  <div class="hol-box__header">
    <div class="header-title-container title-box-occ">
      <span><mat-icon>mediation</mat-icon></span>
      <span class="word-break">{{ decisionTitle }}</span
      >&nbsp;
      <small *ngIf="isReadOnly || localHourOnly" class="hol-box__subtitle">
        {{ moduleConfig.config.translateKey + '.COMMON.TIMES_LT' | translate }}</small
      >
      <small *ngIf="!isReadOnly && !localHourOnly" class="hol-box__subtitle">
        {{ moduleConfig.config.translateKey + '.COMMON.TIMES_UTC' | translate }}</small
      >
      &nbsp;
      <div *ngIf="hideOptionStatus()">
        <app-ocl-criticality-loading (click)="openCriticityMatrix($event)" [flightStatus]="currentFlightStatus" [readonly]="isReadOnly">
        </app-ocl-criticality-loading>
      </div>

      <div class="fill-space"></div>

      <button
        (click)="openGroupModal()"
        *ngIf="
          (userCanEditCards || userCanEditCards === undefined) &&
          !isReadOnly &&
          !modeLinkIsActivate &&
          (!isItemsRequired || decisionItems.length)
        "
        aria-label="Add new group"
        class="md-icon-button md-raised hol-invert-no-border"
        mat-icon-button=""
        tabindex="-1"
      >
        <mat-icon>scatter_plot</mat-icon>
        <!-- <img src="../../../../assets/images/group-attach.svg"/> -->
      </button>
      <button
        (click)="openAddModal($event)"
        *ngIf="(userCanEditCards || userCanEditCards === undefined) && !isReadOnly && !modeLinkIsActivate"
        aria-label="Add decision"
        class="md-icon-button md-raised"
        mat-icon-button=""
      >
        <i class="fa fa-plus"></i>
      </button>
    </div>
    <div class="header-action-container">
      <mat-checkbox
        *ngIf="enableViewGroup"
        [(ngModel)]="isSetGroups"
        [disabled]="isReadOnly || modeLinkIsActivate"
        [labelPosition]="'after'"
        color="primary"
      >
        <span class="checkbox-label">{{ moduleConfig.config.translateKey + '.DASHBOARD.EVENTS.GROUP_CHECKBOX' | translate }}</span>
      </mat-checkbox>
    </div>
  </div>

  <div class="hol-box__content">
    <div class="occ-table">
      <div class="iscroll-wrapper" iscroll iscroll-indicator iscroll-instance="indicator">
        <div class="iscroll-scroller">
          <ul *ngIf="emptyDecisionsGroup.length" class="hol-list">
            <ng-container *ngFor="let emptyGroup of emptyDecisionsGroup; trackBy: trackByFn">
              <li *ngIf="isSetGroups && emptyGroup.objectId" [@EnterLeave]="'flyIn'">
                <app-ocl-container-group-item
                  [airportsCode]="airportsCode"
                  [decisionItems]="decisionItems"
                  [events]="events"
                  [group]="emptyGroup"
                  [groupsFromApi]="groupsFromApi"
                  [isReadOnly]="isReadOnly"
                  [isSummaryActivated]="isSummaryActivated"
                  [linkedIds]="linkedIds"
                  [logBookItems]="logBookItems"
                  [modeLinkIsActivate]="modeLinkIsActivate"
                  [type]="'DECISION'"
                  [userCanEditCards]="userCanEditCards"
                  [utcDisplay]="utcDisplay"
                ></app-ocl-container-group-item>
              </li>
            </ng-container>
          </ul>
          <ul *ngIf="decisionsGrouped.length; else noResultDecisionOccTemplate" class="hol-list">
            <ng-container
              *ngIf="
                decisionsGrouped
                  | occSearchDashboard: searchCriteriasForPipe:context
                  | aclGroupFilter: RolesService.companiesRolesFilter as decisionsFilteredFromPipe
              "
            >
              <ng-container *ngFor="let decisionGroup of decisionsFilteredFromPipe; trackBy: trackByFn">
                <li
                  *ngIf="
                    decisionGroup.displayInGroupViewStatus === 'ALWAYS_VISIBLE' ||
                    (isSetGroups && decisionGroup.objectId) ||
                    (!isSetGroups && decisionGroup.displayInGroupViewStatus === 'NOT_VISIBLE_IN_GROUP_VIEW')
                  "
                  [@EnterLeave]="'flyIn'"
                >
                  <app-ocl-container-group-item
                    [airportsCode]="airportsCode"
                    [decisionItems]="decisionItems"
                    [decisionToDisplay]="decisionGroup.getMostCriticalInfo() || decisionGroup.getMostRecentDecision()"
                    [events]="events"
                    [group]="decisionGroup"
                    [groupsFromApi]="groupsFromApi"
                    [isReadOnly]="isReadOnly"
                    [isSummaryActivated]="isSummaryActivated"
                    [linkedIds]="linkedIds"
                    [logBookItems]="logBookItems"
                    [modeLinkIsActivate]="modeLinkIsActivate"
                    [type]="'DECISION'"
                    [userCanEditCards]="userCanEditCards"
                    [utcDisplay]="utcDisplay"
                  ></app-ocl-container-group-item>
                </li>
              </ng-container>
              <div *ngIf="decisionsFilteredFromPipe.length === 0" class="no-result">
                <span>{{ moduleConfig.config.translateKey + '.DASHBOARD.STATUS_DECISIONS.NO_RESULT' | translate }}</span>
              </div>
            </ng-container>
          </ul>
          <ng-template #noResultDecisionOccTemplate>
            <ul class="hol-list">
              <div class="no-result">
                <span>{{ moduleConfig.config.translateKey + '.DASHBOARD.STATUS_DECISIONS.NO_RESULT' | translate }}</span>
              </div>
            </ul>
          </ng-template>
          <div *ngIf="showLoadMore" class="hol-centered-line">
            <button
              (click)="loadMore()"
              [disabled]="
                loading ||
                modeLinkIsActivate ||
                showOnlyIsPinned ||
                filterDataStartDate !== undefined ||
                decisionsService.totalDecisions === decisionItems.length
              "
              class="more-small"
              color="primary"
              mat-raised-button
            >
              <span *ngIf="!loading">{{ 'COMMON.LOAD_MORE' | translate }} (> {{ decisionsService.dateTo | time: !isReadOnly }})</span>
              <span *ngIf="loading">{{ 'COMMON.LOADING' | translate }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
